<template>
  <b-overlay :show="loading" rounded="sm" spinner-variant="primary">
    <transition name="bounce">
      <b-container class="py-5 custom-container container">
        <b-breadcrumb
          :items="items"
          class="pl-0 pt-5 mt-5 bg-transparent"
        ></b-breadcrumb>
        <b-row>
          <b-col
            ><h2 class="font-weight-bold">{{ filename }}</h2></b-col
          >

          <file-options
            v-if="file"
            :file="file"
            @showAlert="showAlert"
            @shareFile="shareFile"
          ></file-options>
        </b-row>
        <b-row class="mx-0 mt-4">
          <b-col sm="12" lg="8" md="8" class="d-flex flex-column"
            ><b-row class="flex-row flex-nowrap overflow-auto" v-if="file">
              <b-col
                sm="6"
                lg="5"
                class="pl-0"
                v-for="file in file.files"
                :key="file.id"
              >
                <b-card
                  no-body
                  class="files"
                  @click="displayPreviewDialog(file)"
                >
                  <b-img-lazy
                    v-bind="mainProps"
                    class="image"
                    :class="file.mime_type === 'image/jpeg' ? 'object-fit' : ''"
                    :src="file.thumb_url"
                  ></b-img-lazy> </b-card></b-col
            ></b-row>
            <b-row class="mt-auto"
              ><b-col cols="12" class="mb-0">
                <b-card class="mt-4 file-details ">
                  <h5 class=" mb-4 font-weight-bold ">
                    File Details
                  </h5>
                  <b-card-body v-if="file" class="pl-0 align-items-center">
                    <b-row
                      class="mb-2"
                      v-for="info in file.file_information_types"
                      :key="info.id"
                    >
                      <b-col
                        cols="7"
                        sm="7"
                        md="4"
                        lg="4"
                        class="font-weight-bold gray--2"
                      >
                        {{ info.label }} </b-col
                      ><b-col cols="5" sm="5" md="4" lg="4" class=" gray--2">{{
                        info.field_type === 'date'
                          ? parseDate(info.value)
                          : info.value
                      }}</b-col></b-row
                    ></b-card-body
                  >
                </b-card></b-col
              >
            </b-row>
          </b-col>

          <b-col v-if="file" sm="12" lg="4" md="4" class="upload-details"
            ><file-upload-details
              :file="file"
              @openShareFile="shareFile"
            ></file-upload-details>
          </b-col>
        </b-row>
        <!-- <b-alert
          class="custom-alert"
          :show="dismissCountDown"
          dismissible
          fade
          variant="primary"
          @dismiss-count-down="countDownChanged"
          >File has been {{ alertMsg }}.</b-alert
        > -->
        <share-file-modal
          :showShareFiles="showShareFiles"
          :selectedFiles="checkedFiles"
          :fileShares="fileShares"
          @closeShareFileModal="showShareFiles = false"
          @fileShareResponsePrompt="shareFileResponsePrompt"
        />

        <b-alert
          class="custom-alert"
          :show="dismissCountDown"
          :class="{
            'bg-danger border-danger': alertType === 'danger'
          }"
          dismissible
          fade
          :variant="alertType"
          @dismiss-count-down="countDownChanged"
        >
          {{ alertMsg }}
        </b-alert>
        <b-modal
          v-if="clickedFile"
          @click:outside="hidePreviewDialog"
          @keydown.esc="hidePreviewDialog"
          v-model="previewDialog.show"
          body-bg-variant="transparent"
          body-class="px-0"
          hide-footer
          hide-header
          centered
          size="lg"
        >
          <vue-pdf-embed
            v-if="previewDialog.type === 'application/pdf'"
            :source="clickedFile"
          />
          <b-img-lazy v-else class="preview" :src="clickedFile"></b-img-lazy>
        </b-modal>
      </b-container>
    </transition>
  </b-overlay>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import FileOptions from '@/components/modals/FileOptions'
import FileUploadDetails from '@/components/cards/FileUploadDetails'
import ShareFileModal from '@/components/modals/ShareFileModal'

import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'

export default {
  components: {
    FileOptions,
    FileUploadDetails,
    ShareFileModal,
    VuePdfEmbed
  },
  data() {
    return {
      loading: false,
      mainProps: {
        center: true,
        blank: true,
        blankColor: '#bbb'
      },
      showShareFiles: false,
      checkedFiles: [],
      fileShares: [],
      dismissCountDown: 0,
      alertMsg: '',
      alertType: 'primary',
      previewDialog: {
        show: false,
        type: null,
        file: null
      },
      clickedFile: null
    }
  },

  computed: {
    ...mapState({
      file: state => state.file.file
    }),
    ...mapGetters('file', ['file']),
    filename() {
      return this.file ? this.file.name : ''
    },
    items() {
      return [
        {
          text: 'Files',
          to: '/file'
        },
        {
          text: this.filename
        }
      ]
    }
  },

  methods: {
    ...mapActions({
      getFile: 'file/getFile'
    }),

    async fetchFile() {
      this.loading = true
      await this.getFile(this.$route.params.id)
      this.loading = false
    },
    shareFile() {
      this.fileShares = this.file.file_shares
      this.showShareFiles = true
    },
    shareFileResponsePrompt(res) {
      if (res.success) {
        this.alertMsg =
          'File shared successfully to selected Business Admin emails: ' +
          res.data.success.join(', ')

        this.dismissCountDown = 15
        this.fetchFile()

        return
      } else {
        this.alertType = 'danger'

        if (res.status === 402) {
          this.alertMsg = 'File shared unsuccessful!'
        } else {
          this.alertMsg =
            'Something went wrong while submitting the share file email!'
        }
      }

      this.dismissCountDown = 5
    },
    showAlert(action) {
      this.dismissCountDown = 1
      // this.alertMsg = action
      this.alertMsg = `File has been ${action}.`
      if (action === 'deleted') {
        this.$router.replace({
          name: 'file.list-page'
        })
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    displayPreviewDialog(file) {
      this.previewDialog.file = file
      this.previewDialog.type = file.mime_type

      this.clickedFile = file.url

      this.togglePreviewDialog()
    },

    hidePreviewDialog() {
      this.togglePreviewDialog()

      this.previewDialog.file = null
    },

    togglePreviewDialog() {
      this.previewDialog.show = !this.previewDialog.show
    }
  },

  async created() {
    await this.fetchFile().then(() => {
      if (this.file) {
        this.checkedFiles.push(this.file.id)
      }
    })
  }
}
</script>
<style lang="scss" scoped>
.file-details {
  height: auto;
}
.card {
  border-radius: 8px;
  opacity: 1;
  margin: 0;
}
.preview-container {
  height: 192px;
  flex-wrap: nowrap;

  @media (max-width: 767px) {
    width: auto;
  }
}
.files {
  height: 192px;
}

.image {
  cursor: pointer;
  height: 100%;
  object-fit: contain;

  @media (min-width: 767px) {
    width: 100%;
  }
}
.preview {
  object-fit: cover;
  cursor: pointer;
  height: 100%;
  width: 100%;
}
.list {
  justify-content: space-around;
}
.upload-details {
  padding-right: 0;

  @media (max-width: 767px) {
    padding-left: 0;
    padding-top: 1.5rem;
  }
}
</style>
